import axios from 'axios'

const wpClient = axios.create({
  baseURL: `${import.meta.env.VITE_WP_BASE_URL}/wp-json/wp/v2`,
  timeout: 12000,
})

wpClient.interceptors.response.use(
  (res) => res.data,
  (err) => Promise.reject(err)
)

export const fetchPageBySlug = (slug) =>
  wpClient.get('/pages', { params: { slug } }).then((pages) => pages[0] ?? null)

export const fetchPostBySlug = (slug) =>
  wpClient
    .get('/posts', { params: { slug, _embed: true } })
    .then((posts) => posts[0] ?? null)
